export const fetchConstants = {
    START: 'FETCH_START',
    CREATE: 'FETCH_CREATE',
    CREATE_END: 'FETCH_CREATE_END',
    SUCCESS: 'FETCH_SUCCESS',
    ERROR: 'FETCH_ERROR',
    ABORT: 'FETCH_ABORT',
};

export const FETCH_WRITE_TYPES = ['CREATE', 'UPDATE', 'DELETE', 'UPLOAD', 'UPDATE_MANY', 'DELETE_MANY'];
